import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import {
  AngularPlugin,
  ApplicationinsightsAngularpluginErrorService,
} from '@microsoft/applicationinsights-angularplugin-js';
import {
  ApplicationInsights,
  DistributedTracingModes,
  ICustomProperties,
  IDependencyTelemetry,
  IEventTelemetry,
  IExceptionTelemetry,
  IMetricTelemetry,
  IPageViewTelemetry,
  ITraceTelemetry,
} from '@microsoft/applicationinsights-web';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApplicationInsightsService {
  myinjector = Injector.create({
    providers: [
      {
        provide: ApplicationinsightsAngularpluginErrorService,
        useClass: ApplicationinsightsAngularpluginErrorService,
      },
    ],
  });

  private angularPlugin = new AngularPlugin(this.myinjector) as any;
  private appInsights = new ApplicationInsights({
    config: {
      // instrumentationKey: environment.appInsights.instrumentationKey,
      connectionString : environment.appInsights.connectionString,
      distributedTracingMode: DistributedTracingModes.W3C,
      enableCorsCorrelation: true,
      enableRequestHeaderTracking: true,
      enableResponseHeaderTracking: true,
      // auto router tracking, default pageview duration will be set to 0

      extensions: [this.angularPlugin],
      extensionConfig: {
        [this.angularPlugin.identifier]: {
          router: this.router,
          useInjector: true,
        },
      },
    },
  });

  constructor(private router: Router) {
    this.appInsights.loadAppInsights();
    this.appInsights.setAuthenticatedUserContext('UserContext');
    this.appInsights.addTelemetryInitializer((envelope) => {
      envelope.tags = envelope.tags || [];
      envelope.tags['ai.cloud.role'] = environment.appInsights.cloudRoleName;
    });
  }
  setAuthenticatedUserContext(
    authenicatiedUserId: string,
    accountId?: string,
    storeInCookie: boolean = true
  ) {
    this.appInsights.setAuthenticatedUserContext(
      authenicatiedUserId,
      accountId,
      storeInCookie
    );
  }
  clearAuthenticatedUserContext() {
    this.appInsights.clearAuthenticatedUserContext();
  }

  // expose tracking methods
  trackEvent(event: IEventTelemetry, customProperties?: ICustomProperties) {
    this.appInsights.trackEvent(event, customProperties);
  }

  startTrackEvent(name?: string) {
    this.appInsights.startTrackEvent(name);
  }

  stopTrackEvent(
    name: string,
    properties?: { [p: string]: string },
    measurements?: { [p: string]: number }
  ): any {
    this.appInsights.stopTrackEvent(name, properties, measurements);
  }

  trackPageView(pageView?: IPageViewTelemetry) {
    this.appInsights.trackPageView(pageView);
  }

  startTrackPage(name?: string) {
    this.appInsights.startTrackPage(name);
  }

  stopTrackPage(
    name?: string,
    url?: string,
    properties?: { [name: string]: string },
    measurements?: { [name: string]: number }
  ) {
    this.appInsights.stopTrackPage(name, url, properties, measurements);
  }

  trackMetric(metric: IMetricTelemetry, properties?: ICustomProperties) {
    this.appInsights.trackMetric(metric, properties);
  }

  trackException(
    exception: IExceptionTelemetry,
    properties?: ICustomProperties
  ) {
    this.appInsights.trackException(exception, properties);
  }

  trackTrace(message: ITraceTelemetry, properties?: ICustomProperties) {
    this.appInsights.trackTrace(message, properties);
  }

  trackDependencyData(dependency: IDependencyTelemetry) {
    this.appInsights.trackDependencyData(dependency);
  }

  flush() {
    this.appInsights.flush();
  }
}
